import { Dispatch } from 'redux';
import axios from 'axios';
import moment from 'moment-mini';

// types
import {
	CANTMAKEIT,
	CREATE_OPPORTUNITY,
	DELETE_OPPORTUNITY,
	GET_OPPORTUNITIES,
	GET_OPPORTUNITIES_COUNT,
	GET_OPPORTUNITIES_REMINDER_TAPE,
	GET_OPPORTUNITY_BY_ID,
	CHANGE_STATUS_MANUAL_OPPORTUNITY,
	RESET_OPPORTUNITIES_RECORDS,
	SET_ERROR,
	UPDATE_OPPORTUNITY,
	GET_OPPORTUNITIES_ALL,
	UPDATE_ACTIVE_STATUS_OPPO,
	JOIN_TO_OPPORTUNITY_BY_VOLUNTEER,
	GET_OPPORTUNITIES_ALL_REPLACE,
	GET_PLACEHOLDERS_ALL,
} from 'redux/actions-types';
import {
	ADMIN_SEARCH_FILTER_TYPE,
	AdminSearchRequest,
	ChangeStatusOpportunityRequest,
	CreateOpportunityRequest,
	DeleteOpportunityRequest,
	ICreateOpportunityRequest,
	IDateRange,
	IOpportunityActiveStatusRequest,
	IOpportunityResponse,
	IUpdateOpportunityRequest,
	PaginationRequest,
	OpportunityActiveStatusRequest,
	OPPORTUNITY_STATUSES,
	SearchOpportunitiesRequest,
	StatusOpportunityVolunteersRequest,
	StatusOpportunityVolunteersRequestStatus,
	UpdateOpportunityRequest,
	ToggleOptOutStatusRequest,
	UpdateManualOpportunityRequest,
	CreateUploadLinkRequest,
} from '@joc/api-gateway';
import { IOpportunitiesCountsResponse, ManualOpportunityInitialValuesType } from 'core/types';
import { Item } from '../../components/Organization/Opportunities/ManualOpportunityForm/UploadSeveralPhotos/ItemPreview';

// API
import { API } from 'core/API';

// functions
import { getFileType, removeEmptyProps } from 'core/functions';

export const getOpportunitiesAllInitial =
	(searchBody: any) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			// TODO: change request to search by admin
			const recordsOpportunitiesResponse = await API.adminSearchOpportunities(
				'',
				SearchOpportunitiesRequest.fromJS({ ...searchBody })
			);
			// console.log('recordsOppotunitiesResponse: ', recordsOppotunitiesResponse);
			dispatch({
				type: GET_OPPORTUNITIES_ALL,
				payload: { records: recordsOpportunitiesResponse.records, total: recordsOpportunitiesResponse.total },
			});
		} catch (error: any) {
			dispatch({ type: SET_ERROR, payload: { state: true, message: error?.response?.message || error.message } });
		}
	};

export const getOpportunitiesAll =
	(searchBody: any) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			const recordsOppotunitiesResponse = await API.adminSearchOpportunities(
				'',
				SearchOpportunitiesRequest.fromJS({ ...searchBody })
			);

			dispatch({
				type: GET_OPPORTUNITIES_ALL_REPLACE,
				payload: { records: recordsOppotunitiesResponse.records, total: recordsOppotunitiesResponse.total },
			});
		} catch (error: any) {
			dispatch({ type: SET_ERROR, payload: { state: true, message: error?.response?.message || error.message } });
		}
	};

export const getAllOpposCounts =
	() =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			const smallPagination = PaginationRequest.fromJS({ skip: 0, take: 1 });
			const getOpposByAdmin = (opportunityFilterType: ADMIN_SEARCH_FILTER_TYPE) =>
				API.searchOpportunitiesByAdmin(
					undefined,
					AdminSearchRequest.fromJS({
						opportunityFilterType,
						pagination: smallPagination,
					})
				);

			const placeholdersResponse = await API.getAllPlacholders();

			dispatch({
				type: GET_PLACEHOLDERS_ALL,
				payload: placeholdersResponse,
			});

			const [
				opportunitiesTotal,
				opportunitiesChallenge,
				opportunitiesPast,
				opportunitiesUpcoming,
				opportunitiesManual,
				opportunitiesPrivate,
			] = await Promise.all([
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.ALL),
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.CHALLENGE),
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.PAST),
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.UPCOMING),
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.SOLO),
				getOpposByAdmin(ADMIN_SEARCH_FILTER_TYPE.PRIVATE),
			]);

			dispatch({
				type: GET_OPPORTUNITIES_COUNT,
				payload: {
					opportunitiesTotal: opportunitiesTotal.total,
					opportunitiesChallenge: opportunitiesChallenge.total,
					opportunitiesPast: opportunitiesPast.total,
					opportunitiesUpcoming: opportunitiesUpcoming.total,
					opportunitiesManual: opportunitiesManual.total,
					opportunitiesPrivate: opportunitiesPrivate.total,
				} as IOpportunitiesCountsResponse,
			});
		} catch (error: any) {
			// eslint-disable-next-line no-console
			console.error(error.message);
		}
	};

export const getOpportunities =
	(searchBody: any) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			if (!searchBody.fullTextSearch?.value) {
				delete searchBody.fullTextSearch;
			}
			const recordsResponse = await API.searchOpportunitiesByOrganisation(
				undefined,
				undefined,
				removeEmptyProps(searchBody)
			);
			dispatch({
				type: GET_OPPORTUNITIES,
				payload: { records: recordsResponse.records, total: recordsResponse.total },
			});
		} catch (error: any) {
			dispatch({ type: SET_ERROR, payload: { state: true, message: error?.response?.message || error.message } });
		}
	};

export const getOpportunityById =
	(id: number) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			const response = await API.getOpportunityById(id, '');
			dispatch({
				type: GET_OPPORTUNITY_BY_ID,
				payload: response,
			});
		} catch (error: any) {
			console.error(error.message);
		}
	};

export const resetOpportunities =
	() =>
	(dispatch: Dispatch): void => {
		dispatch({
			type: RESET_OPPORTUNITIES_RECORDS,
		});
	};

export const getOpportunitiesCount =
	(orgId: string) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			const response = await API.countsOpportunities(Number(orgId));
			dispatch({ type: GET_OPPORTUNITIES_COUNT, payload: response });
		} catch (error: any) {
			// eslint-disable-next-line no-console
			console.error(error.message);
		}
	};

export const createOpportunity =
	(values: ICreateOpportunityRequest) =>
	async (dispatch: Dispatch): Promise<IOpportunityResponse> => {
		try {
			if (values.organisationId) {
				const response = await API.createOpportunity(
					undefined,
					undefined,
					CreateOpportunityRequest.fromJS(values)
				);
				dispatch({ type: CREATE_OPPORTUNITY, payload: response });
				return response;
			}
			throw new Error('We can not find your organisation id');
		} catch (error: any) {
			throw error;
		}
	};

export const createManualOpportunity =
	(values: ICreateOpportunityRequest) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			const response = await API.createManualOpportunityByVolunteer(CreateOpportunityRequest.fromJS(values));
			dispatch({ type: CREATE_OPPORTUNITY, payload: response });
		} catch (error: any) {
			console.error(error.message);
		}
	};

export const updateOpportunity = (id: number, values: IUpdateOpportunityRequest) => async (dispatch: Dispatch) => {
	try {
		const response = await API.adminUpdateOpportunity(id, UpdateOpportunityRequest.fromJS(values));
		dispatch({ type: UPDATE_OPPORTUNITY, payload: response });
	} catch (error: any) {
		console.error(error.message);
	}
};

// TODO: finished version on Volunteer & Admin solutions
const uploadFilesToBackEnd = async (items: Array<Item>): Promise<Array<string>> => {
	const uploadLinkResponse = await Promise.all(
		items.map(item =>
			API.createPreSignedUrl(
				CreateUploadLinkRequest.fromJS({
					fileName: item.file?.name,
					fileType: item.file?.type,
				})
			)
		)
	);

	const s3BucketResponse = await Promise.all(
		uploadLinkResponse.map((link, i) =>
			axios.put(link.upoloadLink, items[i].file, {
				headers: {
					'Access-Control-Allow-Origin': null,
					'Content-Type': items[i].file?.type,
				},
				onUploadProgress: (progressEvent: ProgressEvent) => {
					const loadingPayload = {
						percent: Math.round((progressEvent.loaded / items[i].file!?.size) * 100),
						itemId: link.upoloadLink,
						filename: items[i].file?.name,
					};

					// eslint-disable-next-line no-console
					console.log({ loadingPayload });
				},
			})
		)
	)
		.then(files => {
			// eslint-disable-next-line no-console
			console.log({ files });
			return files;
		})
		.catch(error => {
			// eslint-disable-next-line no-console
			console.log({ error });
			return error;
		});

	if (!s3BucketResponse.length) {
		return [];
	}

	return uploadLinkResponse.map(item => item.newFileName);
};

// TODO: finished version on Volunteer & Admin solutions
const updateAdminManualPreparation = async (
	values: IUpdateOpportunityRequest,
	dispatch: Dispatch,
	isNeedUpdateEndTime?: boolean
) => {
	let photosRes: Array<string> = [];

	const formatedStartDate = moment(moment((values as IUpdateOpportunityRequest).startDate).toISOString()).set({
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0,
	});

	const formatedEndDate = moment(formatedStartDate).add(
		(values as unknown as ManualOpportunityInitialValuesType).endTime,
		'hours'
	);

	if (values.filePathes?.length) {
		const files = values.filePathes as unknown as Array<Item>;
		const uploadedFiles = files?.filter(file => file.isNew);
		const backEndFiles = files?.filter(file => !file.isNew).map(file => file.src);
		if (uploadedFiles?.length) {
			const uploadedFilesUrls = await uploadFilesToBackEnd(uploadedFiles);
			photosRes = [...backEndFiles, ...uploadedFilesUrls];
		} else {
			photosRes = backEndFiles;
		}
	}

	return {
		...(values as IUpdateOpportunityRequest),
		startDate: isNeedUpdateEndTime ? formatedStartDate.toDate() : values.startDate,
		endDate: isNeedUpdateEndTime ? formatedEndDate.toDate() : values.endDate,
		filePathes: photosRes as any,
		imagePath: photosRes.reduceRight((res, url) => (getFileType(url) === 'mp4' ? res : url), ''),
	} as unknown as UpdateManualOpportunityRequest;
};

// TODO: finished version on Volunteer & Admin solutions
export const updateAdminOpportunity =
	(id: number, values: IUpdateOpportunityRequest, isNeedUpdateEndTime: boolean) => async (dispatch: Dispatch) => {
		try {
			const requestBody = await updateAdminManualPreparation(values, dispatch, isNeedUpdateEndTime);
			const response = await API.updateManualOpportunity(id, UpdateManualOpportunityRequest.fromJS(requestBody));
			dispatch({ type: UPDATE_OPPORTUNITY, payload: response });
			return response;
		} catch (error) {
			throw error;
		}
	};

export const updateActiveStatus = (data: IOpportunityActiveStatusRequest) => async (dispatch: Dispatch) => {
	try {
		const response = await API.updateOpportunityActiveStatus(OpportunityActiveStatusRequest.fromJS(data));
		dispatch({ type: UPDATE_ACTIVE_STATUS_OPPO, payload: response });
	} catch (error: any) {
		console.error(error.message);
	}
};

export const deleteOpportunity =
	(id: number) =>
	async (dispatch: Dispatch): Promise<void> => {
		try {
			await API.deleteOpportunity(id, DeleteOpportunityRequest.fromJS({}));
			dispatch({ type: DELETE_OPPORTUNITY, payload: id });
		} catch (error: any) {
			console.error(error.message);
			throw error;
		}
	};

export const joinToOpportunity = (id: number) => async (dispatch: Dispatch) => {
	try {
		await API.attachByVolunteer(id);
		const updatedOpportunity = await API.getOpportunityById(id, '');
		dispatch({ type: UPDATE_OPPORTUNITY, payload: updatedOpportunity });
	} catch (error: any) {
		console.error(error.message);
	}
};

export const joinToOpportunityCurrent = (id: number) => async (dispatch: Dispatch) => {
	try {
		await API.attachByVolunteer(id);
		const updatedOpportunity = await API.getOpportunityById(id, '');
		dispatch({ type: JOIN_TO_OPPORTUNITY_BY_VOLUNTEER, payload: updatedOpportunity });
	} catch (error: any) {
		console.error(error.message);
	}
};

export const changeStatusVolunteers =
	(id: number, volunteerIds: Array<number>, status: StatusOpportunityVolunteersRequestStatus) =>
	async (dispatch: Dispatch) => {
		try {
			await API.changeStatusVolunteers(
				id,
				volunteerIds.map(volunteerId =>
					StatusOpportunityVolunteersRequest.fromJS({
						volunteerId,
						status,
					})
				)
			);
			const updatedOpportunity = await API.getOpportunityById(id, '');
			dispatch({ type: UPDATE_OPPORTUNITY, payload: updatedOpportunity });
		} catch (error: any) {
			dispatch({ type: SET_ERROR, payload: { state: true, message: error?.response?.message || error.message } });
		}
	};

export const cantMakeIt = (id: number, userVolunteerId: string) => async (dispatch: Dispatch) => {
	try {
		await API.toggleOpportunityVolunteerStatusCanMakeIt(id, ToggleOptOutStatusRequest.fromJS(undefined));
		dispatch({ type: CANTMAKEIT, payload: { id, userVolunteerId } });
	} catch (error: any) {
		throw error;
	}
};

export const getOpportunitiesReminderTape = (orgId: number, dateRange: IDateRange) => async (dispatch: Dispatch) => {
	try {
		const opportunitiesResponse = await API.searchOpportunitiesByOrganisation(
			undefined,
			undefined,
			SearchOpportunitiesRequest.fromJS({ startDay: dateRange, organisationId: orgId })
		);
		dispatch({ type: GET_OPPORTUNITIES_REMINDER_TAPE, payload: opportunitiesResponse });
	} catch (error: any) {
		throw error;
	}
};

export const changeStatusManualOpportunity =
	(opportunityId: number, opportunityStatus: OPPORTUNITY_STATUSES, rejectionReason?: string) =>
	async (dispatch: Dispatch) => {
		try {
			await API.changeStatusOpportunity(
				undefined,
				ChangeStatusOpportunityRequest.fromJS({
					opportunityId: +opportunityId,
					opportunityStatus,
					rejectionReason,
				})
			);
			dispatch({ type: CHANGE_STATUS_MANUAL_OPPORTUNITY, payload: { id: opportunityId, opportunityStatus } });
		} catch (error: any) {
			dispatch({ type: SET_ERROR, payload: { state: true, message: error?.response?.message || error.message } });
		}
	};
